import { render, staticRenderFns } from "./IletisimListesi.vue?vue&type=template&id=3bd5c91d&scoped=true&"
import script from "./IletisimListesi.vue?vue&type=script&lang=js&"
export * from "./IletisimListesi.vue?vue&type=script&lang=js&"
import style0 from "./IletisimListesi.vue?vue&type=style&index=0&id=3bd5c91d&lang=scss&scoped=true&"
import style1 from "./IletisimListesi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5c91d",
  null
  
)

export default component.exports